"use strict";var DisplayStatus;Object.defineProperty(exports,"__esModule",{value:!0}),function(s){s.VISIBLE="visible",s.HIDDEN="hidden",s.DISABLED="disabled"}(DisplayStatus=exports.DisplayStatus||(exports.DisplayStatus={}));


//////////////////
// WEBPACK FOOTER
// ../node_modules/@iabtcf/cmpapi/lib/status/DisplayStatus.js
// module id = 61
// module chunks = 0